import { Poppins } from "next/font/google";
import localFont from "next/font/local";
import { Theme } from "@mui/material/styles";
import { TypographyOptions } from "@mui/material/styles/createTypography";

//init fonts with next optimization for no shift layout
//https://nextjs.org/docs/pages/building-your-application/optimizing/fonts
//https://nextjs.org/docs/app/building-your-application/optimizing/fonts#google-fonts
export const poppins = Poppins({
  preload: true,
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
  variable: "--poppins",
});

export const generationLight = localFont({
  preload: true,
  display: "swap",
  variable: "--generation1970Light",
  src: "../../public/font/Generation_1970_Light.woff2",
});

export const generationOutline = localFont({
  preload: false,
  display: "swap",
  variable: "--generation1970Outline",
  src: "../../public/font/Generation_1970_Outline.woff2",
});

export const roughwell = localFont({
  preload: true,
  display: "swap",
  variable: "--roughwell",
  src: "../../public/font/Roughwell.woff2",
});

const typography = (theme: Theme): TypographyOptions => ({
  poppins: poppins.style.fontFamily,
  roughwell: roughwell.style.fontFamily,
  generation1970Light: generationLight.style.fontFamily,
  generation1970Outline: generationOutline.style.fontFamily,
  h6: {
    fontFamily: poppins.style.fontFamily,
    fontWeight: 600,
    color: theme.palette.text.primary,
    fontSize: "16px",
    lineHeight: 1.4,
  },
  h5: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "20px",
    color: theme.palette.text.primary,
    fontWeight: 400,
    lineHeight: 1.4,
  },
  h4: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "24px",
    color: theme.palette.text.primary,
    fontWeight: 600,
    lineHeight: 1.4,
    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
    },
  },
  h3: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "32px",
    color: theme.palette.text.primary,
    fontWeight: 600,
    lineHeight: 1.4,
    [theme.breakpoints.down("md")]: {
      fontSize: "24px",
    },
  },
  h2: {
    fontFamily: roughwell.style.fontFamily,
    fontSize: "36px",
    color: theme.palette.text.primary,
    fontWeight: 300,
    lineHeight: "42px",
    [theme.breakpoints.down("md")]: {
      fontSize: "30px",
    },
  },
  h1: {
    fontFamily: roughwell.style.fontFamily,
    fontSize: "52px",
    color: theme.palette.text.primary,
    fontWeight: 700,
    [theme.breakpoints.down("md")]: {
      fontSize: "42px",
    },
  },
  subtitle1: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "16px",
    fontWeight: 500,
    color: theme.palette.text.primary,
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.5,
  },
  caption: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "14px",
    color: theme.palette.text.secondary,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body1: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px",
    color: theme.palette.text.primary,
  },
  body2: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: theme.palette.text.primary,
  },
  button: {
    fontFamily: poppins.style.fontFamily,
    textTransform: "capitalize",
  },
  tiny: {
    fontFamily: poppins.style.fontFamily,
    fontSize: "11px",
    fontWeight: 400,
    lineHeight: "20px",
    color: theme.palette.text.secondary,
  },
});

export default typography;
